
import React, { useEffect, useState } from "react";
import {
  names,
  relationship,
} from "../../../core/common/selectoption/selectoption";
import { Button, Select } from "antd";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../router/all_routes";
import { _get, _post } from "../../Utils/Helper";
import { toast } from "react-toastify";
import CommonSelect, { Option } from "../../../core/common/commonSelect";
import { SingleValue } from "react-select";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";

interface FormState {
  query_type: string;
  fullname: string;
  phone_no: string;
  email_address: string;
  ralationship: string;
  is_gurdian: string;
  occupation: string;
  school_id: string;
  [key: string]: any;
}
interface EditFormState {
  query_type: string;
  fullname: string;
  phone_no: string;
  email_address: string;
  [key: string]: any;
}
interface ParentModalProps {
  onSuccess?: () => void;
}
interface EditParentModalProps {
  parentId: number | null;
  onSuccess: () => void;
  onClose: () => void;
}
const ParentModal = ({
  parentId,
  onSuccess,
  onClose,
}: EditParentModalProps) => {
  const _form: FormState = {
    query_type: "create",
    fullname: "",
    phone_no: "",
    email_address: "",
    ralationship: "",
    is_gurdian: "",
    occupation: "",
    school_id: "",
  };
  const [parentDetails, setParentDetails] = useState<any>({});
  const _updateForm: EditFormState = {
    query_type: "update-parent",
    fullname:  parentDetails?.fullname,
    phone_no:  parentDetails?.phone_no,
    email_address:  parentDetails?.email_address,
  };
  
  const [form, setForm] = useState<FormState>(_form);
  const [updateForm, setUpdateForm] = useState(_updateForm);
  const [selectedChildren, setSelectedChildren] = useState<string[]>([]);
  const [allChildren, setAllChildren] = useState<any[]>([]);
  const [children, setChildren] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedParent, setSelectedParent] = useState<any>(null);
  const { user } = useSelector((state: RootState) => state.auth);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleUpdateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setUpdateForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (parentId) {
      _get(
        `get-parent?query_type=select&id=${parentId}`,
        (res) => {
          if (res.success && res.results.length > 0) {
            setParentDetails(res.results[0]);
          }
        },
        (err) => console.error(err.message)
      );
    }
  }, [parentId]);

  useEffect(() => {
    if (parentDetails) {
      setUpdateForm({
        query_type: "update-parent",
        fullname: parentDetails?.fullname || "",
        phone_no: parentDetails?.phone_no || "",
        email_address: parentDetails?.email_address || "",
      });
    }
  }, [parentDetails]);

  const handleSubmit = () => {
    setLoading(true);

    const payload = {
      ...form,
      school_id: user.school_id,
    };
    // console.log(payload);

    _post(
      "get-parent",
      payload,
      (res) => {
        setLoading(false);
        if (res.success) {
          toast.success("Parent created successfully");
          setForm(_form);
          onSuccess?.();
        }
      },
      (err) => {
        alert(err || "Error creating parent");
        setLoading(false);
      }
    );
  };
  const handleEditSubmit = () => {
    // if (!selectedParent) return;
    _post(
      "get-parent",
      {
        ...updateForm,
        query_type: "update-parent",
        id: parentId,
        school_id: user.school_id,
      },
      (res) => {
        if (res.success) {
          toast.success(res.message);
          onSuccess?.();
        }
      },
      (err) => toast.error(err.message)
    );
  };
  const routes = all_routes;
  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-tag");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };
  const getModalContainer2 = () => {
    const modalElement = document.getElementById("modal-tag2");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };

  return (
    <>
      {/* Add Parent */}
      <div className="modal fade" id="add_parent">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Parent</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div id="modal-tag2" className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="d-flex align-items-center upload-pic flex-wrap row-gap-3 mb-3">
                      <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                        <i className="ti ti-photo-plus fs-16" />
                      </div>
                      <div className="profile-upload">
                        <div className="profile-uploader d-flex align-items-center">
                          <div className="drag-upload-btn mb-3">
                            Upload
                            <input
                              type="file"
                              className="form-control image-sign"
                              multiple
                            />
                          </div>
                          <Link to="#" className="btn btn-primary mb-3">
                            Remove
                          </Link>
                        </div>
                        <p>Upload image size 4MB, Format JPG, PNG, SVG</p>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="fullname"
                        value={form.fullname}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Phone Number</label>
                      <input
                        type="number"
                        name="phone_no"
                        value={form.phone_no}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Email Address</label>
                      <input
                        type="email"
                        name="email_address"
                        value={form.email_address}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="mb-0">
                      <label className="form-label">Occupation</label>
                      <input
                        type="text"
                        className="form-control"
                        name="occupation"
                        value={form.occupation}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-0">
                      <label className="form-label">Relationship</label>
                      <CommonSelect
                        options={relationship}
                        defaultValue={{
                          label: form.relationship,
                          value: form.relationship,
                        }}
                        handleChange={(newValue: SingleValue<Option>) =>
                          setForm((prev) => ({
                            ...prev,
                            relationship: newValue ? newValue.value : "",
                          }))
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <Link
                  to="#"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </Link>
                <Button
                  type="primary"
                  loading={loading}
                  onClick={handleSubmit}
                  className="btn-primary"
                >
                  {loading ? "Adding..." : "Add Parent"}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Add Parent */}
      {/* Edit Parent */}
      <div className="modal fade" id="edit_parent">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Parent</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div id="modal-tag" className="modal-body ">
                <div className="row">
                {/* {JSON.stringify(parentDetails)} */}
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Name"
                        name="fullname"
                        onChange={handleUpdateChange}
                        value={updateForm.fullname}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Phone Number</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Phone Number"
                        onChange={handleUpdateChange}
                        value={updateForm.phone_no}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Email Address</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Email Address"
                        name="email_address"
                        value={updateForm.email_address}
                        onChange={handleUpdateChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <Link
                  to="#"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  onClick={onClose}
                >
                  Cancel
                </Link>
                <Button type="primary" loading={loading} onClick={handleEditSubmit}>
                  {loading ? "Saving..." : "Save Changes"}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ParentModal;
